import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Search, Bell, User, LogOut, Menu } from 'lucide-react';
import { Button } from './ui/button';
import { authAPI } from '../services/api';

const TopBar = ({ activeTab = 'Productivity', onMenuClick }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await authAPI.logout();
    navigate('/login');
  };
  return (
    <div className="h-14 flex items-center justify-between px-3 md:px-6 bg-white border-b border-gray-200 flex-shrink-0">
      <div className="flex items-center gap-3 md:gap-6">
        {/* Mobile hamburger menu */}
        <button
          onClick={onMenuClick}
          className="md:hidden w-[30px] h-[30px] flex items-center justify-center bg-blue-600 rounded-md hover:bg-blue-700 transition-colors"
        >
          <Menu className="w-5 h-5 text-white" />
        </button>

        <div className="ml-1">
          <h1 className="text-xl md:text-2xl font-semibold text-blue-700">Dashboard</h1>
          <p className="text-xs text-blue-500">{activeTab}</p>
        </div>
      </div>
      <div className="flex items-center gap-1 md:gap-2">
        <button className="hidden sm:flex w-[30px] h-[30px] items-center justify-center bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors">
          <Search className="w-5 h-5 text-gray-600" />
        </button>
        <button className="hidden sm:flex w-[30px] h-[30px] items-center justify-center bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors">
          <Bell className="w-5 h-5 text-gray-600" />
        </button>
        <button className="hidden sm:flex w-[30px] h-[30px] items-center justify-center bg-white border border-gray-200 rounded-md hover:bg-gray-50 transition-colors">
          <User className="w-5 h-5 text-gray-600" />
        </button>
        <Button
          variant="outline"
          className="flex items-center gap-1 md:gap-2 text-xs md:text-sm px-2 md:px-3"
          onClick={handleLogout}
        >
          <LogOut className="w-4 h-4" />
          <span className="hidden sm:inline">Logout</span>
        </Button>
      </div>
    </div>
  );
};

export default TopBar;
